import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        {/* Top Section */}
        <Row className="align-items-center mb-5">
            {/* Content Column */}
            <Col md={8} className="text-md-start text-center">
                <h2 className="heading">Experience the Future of Cloud</h2>
                <p className="description">
                Unlock your cloud's potential with our free trial today!
                </p>
            </Col>

            {/* Buttons Column */}
            <Col md={4} className="text-md-end text-center my-5 mt-md-0">
                <div className="footer-buttons d-flex flex-wrap gap-2 justify-content-center">
                <Button className="btn-primary-custom">Start Free Trial</Button>
                <Button className="btn-outline-custom">Get a Demo</Button>
                </div>
            </Col>
        </Row>
        {/* Middle Section */}
        <Row className="footer-middle my-3 pt-3 align-items-start">
        {/* Address Section (Left) */}
        <Col md={8} className="footer-address text-md-start">

            <div className="footer-social-icons my-4">
                <a href="#" className="social-icon">
                    <FaFacebookF />
                </a>
                <a href="#" className="social-icon">
                    <FaInstagram />
                </a>
                <a href="#" className="social-icon">
                    <FaTwitter />
                </a>
                <a href="#" className="social-icon">
                    <FaLinkedinIn />
                </a>
                <a href="#" className="social-icon">
                    <FaYoutube />
                </a>
            </div>
        </Col>

        {/* Quick Links and Additional Links (Right) */}

        </Row>


        {/* Bottom Section */}
        <Row>
          <Col className="text-center footer-bottom py-4">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookies Settings</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
